var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckDiscountCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM7.29 14.29L3.7 10.7C3.60742 10.6074 3.53398 10.4975 3.48387 10.3765C3.43377 10.2556 3.40798 10.1259 3.40798 9.995C3.40798 9.86407 3.43377 9.73442 3.48387 9.61346C3.53398 9.49249 3.60742 9.38258 3.7 9.29C3.79258 9.19742 3.90249 9.12398 4.02346 9.07387C4.14442 9.02377 4.27407 8.99798 4.405 8.99798C4.53593 8.99798 4.66558 9.02377 4.78654 9.07387C4.90751 9.12398 5.01742 9.19742 5.11 9.29L8 12.17L14.88 5.29C15.067 5.10302 15.3206 4.99798 15.585 4.99798C15.8494 4.99798 16.103 5.10302 16.29 5.29C16.477 5.47698 16.582 5.73057 16.582 5.995C16.582 6.25943 16.477 6.51302 16.29 6.7L8.7 14.29C8.60749 14.3827 8.4976 14.4563 8.37662 14.5064C8.25565 14.5566 8.12597 14.5824 7.995 14.5824C7.86403 14.5824 7.73435 14.5566 7.61338 14.5064C7.4924 14.4563 7.38251 14.3827 7.29 14.29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDiscountCode);
export default __webpack_public_path__ + "static/media/check-discount-code.92479eeacd0d1fa53f23c2bf07fd0d37.svg";
export { ForwardRef as ReactComponent };